import fi from './fi.json';
import en from './en.json';
import bg from './bg.json';
import hr from './hr.json';
import cs from './cs.json';
import da from './da.json';
import nl from './nl.json';
import et from './et.json';
import fr from './fr.json';
import de from './de.json';
import el from './el.json';
import hu from './hu.json';
import ga from './ga.json';
import it from './it.json';
import lv from './lv.json';
import lt from './lt.json';
import mt from './mt.json';
import pl from './pl.json';
import pt from './pt.json';
import ro from './ro.json';
import sk from './sk.json';
import sl from './sl.json';
import es from './es.json';
import sv from './sv.json';

export const messages = {
  fi,
  en,
  bg,
  hr,
  cs,
  da,
  nl,
  et,
  fr,
  de,
  el,
  hu,
  ga,
  it,
  lv,
  lt,
  mt,
  pl,
  pt,
  ro,
  sk,
  sl,
  es,
  sv,
};

export const MESSAGE_KEYS = Object.keys(fi);
